import { useState, useEffect } from "react";
import styles from "./CalendarAgenda.module.css";
import MiniCalendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import CalendarCalendar from "../CalendarCalendar/CalendarCalendar";
import { getProfessionalColor } from "../CalendarCalendar/calendarHelpers";
import api from "../../services/api";

const CalendarAgenda = () => {
  const [value, setValue] = useState(new Date());
  const [professionals, setProfessionals] = useState([]);
  const [professionalColors, setProfessionalColors] = useState({});
  const [selectedProfIds, setSelectedProfIds] = useState([]);
  const [membersLoading, setMembersLoading] = useState(false);

  useEffect(() => {
    setMembersLoading(true);
    api
      .get("/members")
      .then((r) => {
        const data = Array.isArray(r.data) ? r.data : [];
        const profs = data;
        const colors = {};
        profs.forEach((m) => {
          colors[m.id] = getProfessionalColor(m.id);
        });
        setProfessionals(profs);
        setProfessionalColors(colors);
      })
      .catch(() => {
        setProfessionals([]);
        setProfessionalColors({});
      })
      .finally(() => setMembersLoading(false));
  }, []);

  const toggleProfessional = (id) => {
    setSelectedProfIds((prev) =>
      prev.includes(id) ? prev.filter((p) => p !== id) : [...prev, id],
    );
  };

  return (
    <>
      <section className={styles.main}>
        <div className={styles.sidebar}>
          <div className={styles.top}>
            <MiniCalendar onChange={setValue} value={value} />
          </div>
          <div className={styles.mid}>
            <p className={styles.midTitle}>Profissionais</p>
            {membersLoading && <p className={styles.muted}>Carregando...</p>}
            {!membersLoading && professionals.length === 0 && (
              <p className={styles.faint}>Nenhum profissional cadastrado.</p>
            )}
            <ul className={styles.profList}>
              {professionals.map((prof) => {
                const color = professionalColors[prof.id] ?? getProfessionalColor(prof.id);
                const isSelected = selectedProfIds.includes(prof.id);
                return (
                  <li
                    key={prof.id}
                    onClick={() => toggleProfessional(prof.id)}
                    className={styles.profItem}
                    style={{
                      background: isSelected ? `${color}18` : "transparent",
                      borderColor: isSelected ? `${color}55` : "transparent",
                    }}
                    role="button"
                    aria-pressed={isSelected}
                    aria-label={`Filtrar por ${prof.user?.name ?? "profissional"}`}
                  >
                    <span
                      className={styles.profDot}
                      style={{ background: color }}
                    />
                    <span className={styles.profName}>
                      {prof.user?.name ?? "—"}
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <div className={styles.content}>
          {/* A grade detalhada escuta o 'value' e reage a ele */}
          <CalendarCalendar
            currentDate={value instanceof Date ? value : new Date()}
            onDateChange={setValue}
            selectedProfIds={selectedProfIds}
            professionalColors={professionalColors}
            professionals={professionals}
          />
        </div>
      </section>
    </>
  );
};

export default CalendarAgenda;
